var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"step-status",style:(`color: ${_vm.status.color}`)},[_vm._v(_vm._s(_vm.status.message))])
}
var staticRenderFns = []

export { render, staticRenderFns }